import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRsvpSettingsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRsvpSettingsQuery = {
  __typename?: 'Query';
  getRsvpSettingsByEventId?: {
    __typename?: 'RsvpSettings';
    id: string;
    eventId: string;
    deadlineEnabled: boolean;
    deadlineDate?: any | null;
    gracePeriodEnabled: boolean;
    gracePeriodHours: number;
    showDeadline: boolean;
    deadlineStatus: Types.RsvpDeadlineStatus;
    effectiveCutoff?: any | null;
    isOpen: boolean;
  } | null;
};

export type UpdateRsvpSettingsMutationVariables = Types.Exact<{
  payload: Types.UpdateRsvpSettingsPayload;
}>;

export type UpdateRsvpSettingsMutation = {
  __typename?: 'Mutation';
  updateRsvpSettings: {
    __typename?: 'RsvpSettings';
    id: string;
    eventId: string;
    deadlineEnabled: boolean;
    deadlineDate?: any | null;
    gracePeriodEnabled: boolean;
    gracePeriodHours: number;
    showDeadline: boolean;
    deadlineStatus: Types.RsvpDeadlineStatus;
    effectiveCutoff?: any | null;
    isOpen: boolean;
  };
};

export const GetRsvpSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRsvpSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRsvpSettingsByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gracePeriodEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gracePeriodHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showDeadline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveCutoff' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRsvpSettingsQuery__
 *
 * To run a query within a React component, call `useGetRsvpSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRsvpSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRsvpSettingsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRsvpSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRsvpSettingsQuery, GetRsvpSettingsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRsvpSettingsQuery, GetRsvpSettingsQueryVariables>(GetRsvpSettingsDocument, baseOptions);
}
export function useGetRsvpSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRsvpSettingsQuery, GetRsvpSettingsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRsvpSettingsQuery, GetRsvpSettingsQueryVariables>(GetRsvpSettingsDocument, baseOptions);
}
export type GetRsvpSettingsQueryHookResult = ReturnType<typeof useGetRsvpSettingsQuery>;
export type GetRsvpSettingsLazyQueryHookResult = ReturnType<typeof useGetRsvpSettingsLazyQuery>;
export type GetRsvpSettingsQueryResult = Apollo.QueryResult<GetRsvpSettingsQuery, GetRsvpSettingsQueryVariables>;
export const UpdateRsvpSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRsvpSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRsvpSettingsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRsvpSettings' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gracePeriodEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gracePeriodHours' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showDeadline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'effectiveCutoff' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateRsvpSettingsMutationFn = Apollo.MutationFunction<UpdateRsvpSettingsMutation, UpdateRsvpSettingsMutationVariables>;

/**
 * __useUpdateRsvpSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateRsvpSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRsvpSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRsvpSettingsMutation, { data, loading, error }] = useUpdateRsvpSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRsvpSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRsvpSettingsMutation, UpdateRsvpSettingsMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateRsvpSettingsMutation, UpdateRsvpSettingsMutationVariables>(UpdateRsvpSettingsDocument, baseOptions);
}
export type UpdateRsvpSettingsMutationHookResult = ReturnType<typeof useUpdateRsvpSettingsMutation>;
export type UpdateRsvpSettingsMutationResult = Apollo.MutationResult<UpdateRsvpSettingsMutation>;
export type UpdateRsvpSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateRsvpSettingsMutation, UpdateRsvpSettingsMutationVariables>;
